/**
 * @generated SignedSource<<32943cb939a647f88c5f6a504ef7d589>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording$data = {
  readonly detectedLanguage?: string | null;
  readonly id?: string;
  readonly languageConfidenceScore?: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"RegenerateForLanguageModalFragment_meetingRecording">;
  readonly " $fragmentType": "TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording";
};
export type TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording$key = {
  readonly " $data"?: TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_LowLanguageConfidenceRegenerationBanner_meetingRecording",
  "selections": [
    {
      "condition": "public",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "detectedLanguage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "languageConfidenceScore",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RegenerateForLanguageModalFragment_meetingRecording"
            }
          ],
          "type": "MeetingRecording",
          "abstractKey": null
        }
      ]
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};

(node as any).hash = "e720b947a79c6d017f56f7393da977d6";

export default node;
